export enum TabViews {
    NOT_IN_TEAMS = 1,
    REQUIRE_CONSENT = 2,
    LOADING = 3,
    FULL = 4,
    USER_DOES_NOT_HAVE_EMAIL = 5,
    USER_NOT_IN_SYSTEM_ORG_NOT_SUPPORT_TEAMS = 6,
    UNKNOWN_ERROR = 7
}
